// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const BackDropWrapper = styled.div`
  position: absolute;
  height: ${props => `calc(100vh - ${props.top}px)`};
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => (theme.name === 'brightworld'
    ? 'rgba(86, 112, 122, 0.75)'
    : theme.colors.shades[0])};
  z-index: 3;
  opacity: 0.5;
`;

const BackDrop = props => (
  <BackDropWrapper style={{ top: props.positionTop }} top={props.positionTop} />
);

BackDrop.propTypes = {
  positionTop: PropTypes.number
};

BackDrop.defaultProps = {
  positionTop: 0
};

export default BackDrop;
